import styled from "styled-components";
import { Button } from "@mui/material";

// Main container
export const OrderDetailContainer = styled.div`
  min-height: 100vh;

  padding: 0;

  @media (min-width: 768px) {
    padding: 20px;
  }

  @media (min-width: 1024px) {
    padding: 24px;
    max-width: 800px;
    margin: 0 auto;
  }
`;

// Header section
export const HeaderSection = styled.div`
padding: 16px 0px 16px 0px;
  border-bottom: 1px solid #e2e2e2;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderTitle = styled.h1`
  font-size: 16px;
  font-weight: 500;
  margin: 0;
color: #9A9A9A;

  @media (min-width: 768px) {
    font-size: 18px;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
  }
`;

// Main content layout
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  background: white;

  @media (min-width: 768px) {
    border-radius: 0 0 8px 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  @media (min-width: 1024px) {
    gap: 0;
  }
`;

export const LeftColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const RightColumn = styled.div`
  width: 100%;
`;

// Card components
export const Card = styled.div`
  background: white;
  border-bottom: 1px solid #f3f4f6;

  @media (min-width: 768px) {
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    border: 1px solid #e5e7eb;
    margin-bottom: 16px;
  }
`;

export const CardHeader = styled.div`
  padding: 16px 16px 12px 16px;
  border-bottom: none;

  @media (min-width: 768px) {
    padding: 20px 20px 16px 20px;
  }

  @media (min-width: 1024px) {
    padding: 24px 24px 20px 24px;
  }
`;

export const CardTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 17px;
  }

  @media (min-width: 1024px) {
    font-size: 18px;
  }
`;

export const CardContent = styled.div`
  padding: 0 16px 16px 16px;

  @media (min-width: 768px) {
    padding: 0 20px 20px 20px;
  }

  @media (min-width: 1024px) {
    padding: 0 24px 24px 24px;
  }
`;

// Order items section
export const OrderItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const OrderItem = styled.div`
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #e2e2e2;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  &:first-child {
    padding-top: 0;
  }

  @media (min-width: 768px) {
    padding: 16px 0;
    gap: 16px;
  }

  @media (min-width: 1024px) {
    padding: 20px 0;
    gap: 20px;
  }
`;

export const ItemImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
  background-color: #f9fafb;

  @media (min-width: 768px) {
    width: 50px;
    height: 50px;
    border-radius: 8px;
  }

  @media (min-width: 1024px) {
    width: 60px;
    height: 60px;
  }
`;

export const ItemDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ItemName = styled.h3`
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  line-height: 1.3;

  @media (min-width: 768px) {
    font-size: 15px;
  }

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

export const ItemIngredients = styled.p`
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  line-height: 1.3;

  @media (min-width: 768px) {
    font-size: 13px;
  }

  @media (min-width: 1024px) {
    font-size: 14px;
  }
`;

export const ItemPriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
  gap: 16px;

  @media (min-width: 768px) {
    gap: 20px;
  }

  @media (min-width: 1024px) {
    gap: 24px;
  }
`;

export const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const QuantityButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #d1d5db;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f9fafb;
    border-color: #9ca3af;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 14px;
    height: 14px;
    color: #6b7280;
  }
`;

export const QuantityDisplay = styled.span`
  font-size: 14px;
  font-weight: 500;
  min-width: 16px;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 15px;
  }

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

export const ItemPrice = styled.span`
  font-size: 14px;
  font-weight: 600;

  @media (min-width: 768px) {
    font-size: 15px;
  }

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

// Food Options Display Components
export const FoodOptionsContainer = styled.div`
  padding: 8px 0;
  color: #5a5a5a;
`;

export const FoodOptionType = styled.div`
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FoodOptionTypeName = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

export const FoodOptionsList = styled.div`
  display: flex;
  flex-direction:column;
`;

export const FoodOptionItem = styled.div`
`;

export const FoodOptionName = styled.span`
  font-weight: 400;
  font-size:13px;
`;

// Mobile-specific food options components
export const MobileFoodOptionsContainer = styled.div`
  margin-top: 8px;
  color: #5a5a5a;
`;

export const MobileFoodOptionType = styled.div`
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const MobileFoodOptionTypeName = styled.div`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 8px;
`;

export const MobileFoodOptionsList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MobileFoodOptionItem = styled.div`
  display: flex;
  font-size: 12px;
`;

export const MobileFoodOptionName = styled.span`
  font-weight: 400;
  font-size: 14px;
`;

// Modal Components
export const ModalOverlay = styled.div<{ $visible?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ $visible }) => ($visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  z-index: 9999;

  @media (max-width: 767px) {
    z-index: 10000;
    padding: 16px;
  }
`;

export const ModalContent = styled.div<{ $visible?: boolean }>`
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  display: ${({ $visible }) => ($visible ? "block" : "none")};

  @media (max-width: 767px) {
    width: 95%;
    max-height: 85vh;
    padding: 16px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e2e2;
`;

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  // color: #E39435;
  margin: 0;
`;

export const ModalTitleName = styled.h5`
  font-size: 18px;
  font-weight: 600;
  // color: #76B041;
  margin: 0;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #374151;
  }
`;

export const ModalFoodOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalFoodOptionType = styled.div`
  border-radius: 6px;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const ModalFoodOptionTypeName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #76b041;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ModalFoodOptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ModalFoodOptionItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const ModalFoodOptionName = styled.span`
  font-weight: 500;
  color: #e39435;
  font-size: 14px;
`;

export const ModalFoodOptionDetails = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ModalFoodOptionCount = styled.span`
  color: #6b7280;
  font-size: 14px;
`;

export const ModalFoodOptionPrice = styled.span`
  font-weight: 500;
  font-size: 14px;
`;

// Delivery information
export const DeliveryInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AddressSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const AddressLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const AddressText = styled.p`
  font-size: 14px;
  margin: 0;
  line-height: 1.4;

  @media (min-width: 768px) {
    font-size: 15px;
  }

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

export const SpecialInstructions = styled.div`
  background: #f9fafb;
  border-radius: 6px;
  padding: 12px;
  border-left: 3px solid #e5e7eb;

  @media (min-width: 768px) {
    padding: 16px;
    border-radius: 8px;
  }
`;

export const InstructionsLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  display: block;
  margin-bottom: 4px;
`;

export const InstructionsText = styled.p`
  font-size: 13px;
  margin: 0;
  line-height: 1.4;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

export const ContactlessOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #f0f9ff;
  border-radius: 6px;
  border: 1px solid #e0f2fe;

  @media (min-width: 768px) {
    padding: 12px 16px;
    border-radius: 8px;
  }
`;

export const ContactlessIcon = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #0ea5e9;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 10px;
    height: 10px;
    color: white;
  }
`;

export const ContactlessText = styled.span`
  font-size: 13px;
  color: #0c4a6e;
  font-weight: 500;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

// Payment information
export const PaymentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PaymentMethod = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #f3f4f6;

  @media (min-width: 768px) {
    padding: 16px;
    border-radius: 8px;
  }
`;

export const PaymentIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;

  svg {
    width: 18px;
    height: 18px;
    color: #6b7280;
  }

  @media (min-width: 768px) {
    width: 40px;
    height: 40px;
    border-radius: 8px;
  }
`;

export const PaymentDetails = styled.div`
  flex: 1;
`;

export const PaymentType = styled.span`
  font-size: 14px;
  font-weight: 500;
  display: block;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;

export const PaymentNumber = styled.span`
  font-size: 12px;
  color: #6b7280;

  @media (min-width: 768px) {
    font-size: 13px;
  }
`;

// Order summary
export const OrderSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: 768px) {
    gap: 10px;
  }

  @media (min-width: 1024px) {
    gap: 12px;
  }
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;

  @media (min-width: 768px) {
    padding: 4px 0;
  }
`;

export const SummaryLabel = styled.span`
  font-size: 14px;
  color: #6b7280;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;

export const SummaryValue = styled.span`
  font-size: 14px;
  font-weight: 500;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;

export const TotalRow = styled(SummaryRow)`
  padding-top: 8px;
  border-top: 1px solid #f3f4f6;
  margin-top: 4px;

  @media (min-width: 768px) {
    padding-top: 12px;
    margin-top: 8px;
  }
`;

export const TotalLabel = styled(SummaryLabel)`
  font-weight: 600;
  font-size: 15px;

  @media (min-width: 768px) {
    font-size: 16px;
  }

  @media (min-width: 1024px) {
    font-size: 17px;
  }
`;

export const TotalValue = styled(SummaryValue)`
  font-weight: 700;
  font-size: 16px;

  @media (min-width: 768px) {
    font-size: 17px;
  }

  @media (min-width: 1024px) {
    font-size: 18px;
  }
`;

// Action buttons
export const ActionButton = styled(Button)`
  && {
    width: 100%;
    padding: 12px 20px;
    background-color: #ea580c;
    color: white;
    font-weight: 600;
    border-radius: 6px;
    text-transform: none;
    font-size: 15px;
    margin-top: 16px;

    &:hover {
      background-color: #dc2626;
    }

    &:disabled {
      background-color: #d1d5db;
      color: #9ca3af;
    }

    @media (min-width: 768px) {
      padding: 14px 24px;
      font-size: 16px;
      border-radius: 8px;
      margin-top: 20px;
    }

    @media (min-width: 1024px) {
      padding: 16px 32px;
      font-size: 17px;
      margin-top: 24px;
    }
  }
`;

// Responsive utilities
export const MobileOnly = styled.div`
  display: block;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const TabletUp = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`;

export const DesktopOnly = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }
`;

// Web-specific components for OrderDetailWeb
export const WebContainer = styled.div`
  min-height: 100vh;
`;

export const WebWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const WebHeader = styled.div`
  padding: 40px 0;
  margin-bottom: 16px;
`;

export const WebHeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
`;

export const WebTitle = styled.h1`
  font-size: 24px;
  font-weight: 500;
  color: #5a5a5a;
  margin: 16px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const WebTitleIcon = styled.img`
  width: 47px;
  height: 61px;
`;

export const WebMainContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 32px;
  align-items: start;

  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const WebLeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const WebRightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// Mobile-specific components for OrderDetailMobile
export const MobileHeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MobileHeaderTop = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MobileHeaderDetails = styled.div`
  font-size: 14px;
  color: #5A5A5A;

`;

export const MobileSingleColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  background: white;
`;

export const MobileItemsSection = styled.div`
  border-bottom: 1px solid #e2e2e2;
`;

export const MobileItemsTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px 0;
`;

export const MobileItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MobileOrderItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0px 16px 0px;
  border-bottom: 1px solid #e2e2e2;
  &:last-child {
    border: none;
  }
`;

export const MobileItemImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background-color: #f3f4f6;
  object-fit: cover;
`;

export const MobileItemContent = styled.div`
  flex: 1;
`;

export const MobileItemName = styled.div`
  font-size: 14px;
  font-weight: 600;
`;

export const MobileItemPricing = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
`;

export const MobileQuantity = styled.span`
`;

export const MobilePrice = styled.span`
  font-weight: 600;
`;

export const MobileSummarySection = styled.div`
padding: 16px 0px 16px 0px;
`;

export const MobileSummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MobileSummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
`;

export const MobileSummaryLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const MobileSummaryValue = styled.span`
  font-weight: 500;
`;

export const MobileTotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  padding-top: 16px;
  border-top: 1px solid #e2e2e2;
  margin-top: 8px;
`;

export const MobileTotalLabel = styled.span`
`;

export const MobileTotalValue = styled.span`
`;

// Custom Table Components
export const CustomTable = styled.div`
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e2e2;
  overflow: hidden;
  margin-bottom: 32px;
`;

export const CustomTableHead = styled.div`
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
`;

export const CustomTableRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  align-items: center;
  min-height: 60px;
  border-bottom: 1px solid #e2e2e2;

  &:last-child {
    border-bottom: none;
  }
`;

export const CustomTableHeader = styled.div`
  padding: 16px 20px;
  font-weight: 500;
  color: #000000;
  font-size: 14px;
  text-align: center;

  &:first-child {
    text-align: left;
    min-width: 300px;
  }
`;

export const CustomTableCell = styled.div`
  padding: 16px 20px;
  font-size: 14px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    text-align: left;
    justify-content: flex-start;
    min-width: 300px;
  }
`;

export const CustomTableBody = styled.div`
  background: white;
`;

export const TableItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const TableItemImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
  background-color: #f3f4f6;
`;

export const TableItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TableItemName = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 1.3;
`;

export const TableItemIngredient = styled.span`
  color: #6b7280;
  font-size: 12px;
  line-height: 1.3;
`;

// Info Cards
export const InfoCard = styled.div`
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e2e2;
  overflow: hidden;
`;

export const InfoCardHeader = styled.div`
  background: #f8fafc;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
`;

export const InfoCardTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  border-bottom: 1px solid #e5e7eb;
  padding: 16px 0px 16px 0px;
`;

export const InfoCardContent = styled.div`
  padding: 20px;
`;

export const InfoSection = styled.div`
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoSectionDeliverTo = styled.div`
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoLabel = styled.div`
  font-size: 18px;
  font-weight: 700;
`;

export const InfoValue = styled.div`
  font-size: 16px;
  color: #5a5a5a;
  line-height: 1.4;
`;

// Payment Method Components
export const PaymentMethodsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PaymentMethodCard = styled.div<{ $isSelected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
  padding: 16px 0px 16px 0px;
`;

export const WebTotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0px 12px 0px;
`;

export const PaymentMethodIcon = styled.div<{ $type?: string }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.$type === "cash" ? "#d97706" : "#1a56db"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
`;

export const PaymentMethodText = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #5a5a5a;
`;

export const PaymentMethodLabel = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #5a5a5a;
`;

// Contactless Delivery
export const ContactlessDelivery = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
`;

export const ContactlessCheckbox = styled.div`
  width: 16px;
  height: 16px;
  background-color: #d97706;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
`;

export const ContactlessLabel = styled.span`
  font-size: 14px;
  color: #374151;
`;

// Summary Components (for web)
export const WebSummaryContainer = styled.div`
  background: #f6f6f6;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const WebSummaryHeader = styled.div`
  background: #f8fafc;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
`;

export const WebSummaryTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin: 0;
`;

export const WebSummaryContent = styled.div`
  padding: 16px 20px;
`;

export const WebTotalValue = styled.div`
  font-size: 21px;
  font-weight: 700;
  color: #5a5a5a;
`;

// Loading Components
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  background: white;
  border-radius: 8px;
`;

export const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #f3f4f6;
  border-top: 3px solid #76B041;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

// Error Components
export const ErrorContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const ErrorMessage = styled.h2`
  font-size: 18px;
  color: #6b7280;
  margin: 0;
`;

// Footer placeholder
export const FooterPlaceholder = styled.div`
  height: 100px;
  background: #f8fafc;
  margin-top: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 14px;
`;

// Back Button for Web
export const WebBackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
  transition: all 0.2s;

  &:hover {
    background-color: #f9fafb;
    border-color: #d1d5db;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
